var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab tall flex-1 no-min-width flex items-center"},[_c('i',{class:_vm.iconClassName}),_c('span',{staticClass:"capitalize select-none break-words"},[_vm._v(_vm._s(_vm.tabText))])])}
var staticRenderFns = []

export { render, staticRenderFns }